import { Button, Center, CloseButton, HStack, Text, VStack } from '@chakra-ui/react';
import { DownloadIcon, WarningTwoIcon } from '@chakra-ui/icons';
import React, { useState } from 'react';

export const OfficePreviewNotice = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <HStack
      align="flex-start"
      bg="blue.50"
      color="gray.600"
      px={3}
      py={2}
      mb={2}
      borderRadius="md"
      spacing={2}
    >
      <Text fontSize="xs" flex="1">
        Office previews require the online Microsoft viewer. If the preview is blank or blocked,
        download the document instead.
      </Text>
      <CloseButton
        size="sm"
        mt="-2px"
        onClick={() => setIsVisible(false)}
        aria-label="Dismiss Office preview notice"
      />
    </HStack>
  );
};

export const DocumentPreviewFallback = ({
  file,
  onDownload,
  isDownloading = false,
  message = 'A preview is not available for this document.',
}) => (
  <Center h="100%" minH="300px" p={6} bg="gray.50">
    <VStack spacing={3} maxW="520px" textAlign="center">
      <WarningTwoIcon boxSize={8} color="orange.400" />
      <Text fontWeight="semibold" color="gray.700">Preview unavailable</Text>
      <Text fontSize="sm" color="gray.500">{message}</Text>
      {file?.name && (
        <Text fontSize="sm" color="gray.600" fontWeight="medium" noOfLines={2}>
          {file.name}
        </Text>
      )}
      <Button
        size="sm"
        colorScheme="blue"
        leftIcon={<DownloadIcon />}
        onClick={onDownload}
        isLoading={isDownloading}
        loadingText="Downloading"
      >
        Download document
      </Button>
    </VStack>
  </Center>
);

export class DocumentPreviewErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(previousProps) {
    if (previousProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) return this.props.fallback;
    return this.props.children;
  }
}
